import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Row } from "components/Containers";
import { colors, fontSize } from "style";

/**
 * ApplicantInvitationRate
 *
 * @param {Object} data
 */
const ApplicantInvitationRate = ({ data }) =>
  data?.invitationConversionRate ? (
    <Row gap="0.4rem" noWrap>
      <FormattedMessage
        id="Missions.Applicants.ApplicantInvitationRate"
        values={{
          rate: <div css={styles.icon_container}>{data?.invitationConversionRate}%</div>,
        }}
      />
    </Row>
  ) : null;

const styles = {
  icon_container: css`
    background: ${colors.grayAnatomyLight3};
    font-size: ${fontSize.xxsmall};
    border-radius: 1rem;
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
};

ApplicantInvitationRate.propTypes = {
  data: PropTypes.shape({
    invitationConversionRate: PropTypes.number,
  }).isRequired,
};

export default ApplicantInvitationRate;
